import Vue from 'vue';
import Vuex from 'vuex';

import DealerData from './modules/dealer-data.js';
import CustomerData from './modules/customer-data.js';
import Layout from './modules/layout.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        DealerData,
        CustomerData,
        Layout,
    },
    strict: debug,
});